import { Moon, Sun } from 'lucide-react'
import { useTheme } from '@/lib/theme'

interface ThemeToggleProps {
  className?: string
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, toggle } = useTheme()
  const isDark = theme === 'dark'

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      className={[
        'inline-flex items-center justify-center cursor-pointer',
        'w-9 h-9 rounded-[10px]',
        'border border-[var(--color-border)]',
        'bg-[var(--color-elev-strong)] backdrop-blur',
        'text-[var(--color-text)]',
        'transition-colors duration-200',
        'hover:text-[var(--color-accent)] hover:border-[var(--color-accent)]/50',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-surface)]',
        className ?? '',
      ].join(' ')}
    >
      {isDark ? <Sun size={16} aria-hidden /> : <Moon size={16} aria-hidden />}
    </button>
  )
}
